import { render, staticRenderFns } from "./AssetImageLinkIndex.vue?vue&type=template&id=38cda390&"
import script from "./AssetImageLinkIndex.vue?vue&type=script&lang=js&"
export * from "./AssetImageLinkIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports